import React, { useState, useEffect, useRef } from 'react';
import './PageLayout.css';
import './ExamFlowPage.css';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
const BACKEND_API_URL_RPT = process.env.REACT_APP_API_URL_RPT

const ExamFlowPage: React.FC = () => {
  const navigate = useNavigate()
  const [isCustomElementReady, setIsCustomElementReady] = useState(false);
  const [candidateInfo, setCandidateInfo] = useState<any>(null);
  const examFlowRef = useRef<any>(null);
  const userName = sessionStorage.getItem('userName');
  const userPassword = sessionStorage.getItem('password');
  const identityNumber = userName || " ";
  const password = userPassword || " ";
  const apiBaseUrl = BACKEND_API_URL_RPT;
  const assignedProctor = localStorage.getItem("assignedProctor");

  useEffect(() => {
    const interval = setInterval(() => {
      const log = localStorage.getItem("assignedProctor");
      const redirected = localStorage.getItem("proctorRedirected");

      if (log && !redirected) {
        clearInterval(interval);
        localStorage.setItem("proctorRedirected", "true");
        navigate(`/${Cookies.get("test_engine_project")}/home`, { replace: true });
      }
    }, 500);
 
    return () => clearInterval(interval);
  }, [navigate]);



  useEffect(() => {
    const candidateInfo = sessionStorage.getItem('candidateInfo');
    setCandidateInfo(candidateInfo ? JSON.parse(candidateInfo) : null);
    const checkCustomElement = () => {
      if (customElements.get('exam-flow-web-component')) {
        setIsCustomElementReady(true);
      } else {
        setTimeout(checkCustomElement, 100);
      }
    };
    checkCustomElement();
    setTimeout( () => {
        // examFlowRef?.current.addEventListener('stepChanged', () => alert("stepChanged"));
        // examFlowRef?.current.addEventListener('authenticationStatus', () => alert("authenticationStatus"));
        examFlowRef?.current.addEventListener('flowCompleted', () => {
          navigate('/home');
        });
        // examFlowRef?.current.addEventListener('flowError', () => alert("flowError"));
      }, 0);
  }, []);

  if (!isCustomElementReady) {
    return (
      <div className="exam-flow-page">
        <div className="loading-container">
          <h2>📚 Loading Exam Flow System...</h2>
          <p>Please wait while the Angular component is being loaded...</p>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  ;

  return (
    <div className="exam-flow-page">
      
      {candidateInfo && (
        <exam-flow-web-component
          ref={examFlowRef}
          identity-number={identityNumber}
          password={password}
          rps-examid={candidateInfo?.examid}
          api-base-url={apiBaseUrl}
          asset-base-url="angular-components/angular-app/"
          initial-step="upload-instructions"
          proctoring-type={candidateInfo?.configuration?.proctoringType}
          style={{ width: '100%', height: '100vh' }}
        ></exam-flow-web-component>
      )}

      {/* <exam-flow-web-component
        ref={examFlowRef}
        initial-step="upload-instructions"  // Starting step
        identity-number={identityNumber}            // Candidate ID
        password={password}             // Candidate password
        api-base-url={apiBaseUrl} // API base URL
        onStepChanged={(step: any) => console.log('Step:', step)}
        onFlowCompleted={(data: any) => console.log('Completed:', data)}
        onFlowError={(error: any) => console.error('Error:', error)}
        onAuthenticationStatus={(status: any) => console.log('Auth:', status)}
      /> */}
    </div>
  );
};

export default ExamFlowPage;
